  let items = document.querySelector(".header__inline-menu").querySelectorAll("details"); 
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });

$('.single-slider .slide-list').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  arrows: true,
  slidesToScroll: 1,
  adaptiveHeight: true
});


$('.custom_feature_coll .custom_feature_grid').slick({
  dots: false,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
(() => {
  function removeInvalidViewportTags() {
    document
      .querySelectorAll('meta[name="viewport"]')
      .forEach((meta) => {
        if (!document.head.contains(meta)) {
          meta.remove();
        }
      });
  }

  const viewportObserver = new MutationObserver(
    removeInvalidViewportTags
  );

  viewportObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  removeInvalidViewportTags();
})();


